export default {"src":"/_next/static/media/settings.f57059c6.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};